export const EMPLOYEE_ID = "EMPLOYEE_ID";
export const HIRE_DATE = "HIRE_DATE";
export const DIV_UNIT = "DIV_BUS_DEPT";
export const PAYROLL_SCHEDULE = "PAYROLL_SCHEDULE";
export const POSITION = "POSITION";
export const PRIMARY_MANAGER = "PRIMARY_MANAGER";
export const SECONDARY_MANAGER = "SECONDARY_MANAGER";
export const TIMEGROUP = "TIMEGROUP";
export const LOCATION = "LOCATION";
